module.exports = "/static/assets/dccd5059320d172d1b282564e0d9422d.svg";